import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
    DelegateTicketCms:[],
    message:'',
    isLoading:false,
    isError:false,
    isSuccess:false,
}



////////////////////////////Get All DelegateTicketCms////////////////
export const GetAllDelegateTicketCms = createAsyncThunk('DelegateTicket/GetAllDelegateTicketCms', async(_, thunkAPI)=>{
    try{
        const API_URL = `${process.env.REACT_APP_SERVER_URL}/api/getAllCmsDelegateTicket`
        const response = await axios.get(API_URL)
        return response.data
    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})


export const CreateDelegateTicketCms = createAsyncThunk('DelegateTicket/CreateDelegateTicketCms', async(data, thunkAPI)=>{
    try{
        const token = thunkAPI.getState().auth.user.token
        const config ={
            headers:{
                Authorization: `Bearer ${token}`
            }
        }
        const API_URL = `${process.env.REACT_APP_SERVER_URL}/api/createCmsDelegateTicket`
        const response = await axios.post(API_URL, data, config)
        return response.data
    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})


export const DeleteSingleDelegateTicketCms = createAsyncThunk('DelegateTicket/DeleteSingleDelegateTicketCms', async(id, thunkAPI)=>{
    try{
        const token = thunkAPI.getState().auth.user.token
        const config ={
            headers:{
                Authorization: `Bearer ${token}`
            }
        }
        const API_URL = `${process.env.REACT_APP_SERVER_URL}/api/deleteSingleCmsDelegateTicket/${id}`
        const response = await axios.delete(API_URL, config)
        return response.data
    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})


export const DelegateTicketCmslice = createSlice({
    name:'DelegateTicketCmslice',
    initialState,
    reducers:{
        reset: (state)=> initialState,
        filterState:(state,action)=>{            
            state.DelegateTicketCms = state.DelegateTicketCms.filter((item) => item._id !== action.payload)
        }
    },
    extraReducers:(builder)=>{
        builder
        .addCase(GetAllDelegateTicketCms.pending, (state, action)=>{
            state.isLoading = true
        })
        .addCase(GetAllDelegateTicketCms.fulfilled, (state, action)=>{
            state.isLoading = false
            state.message = action.payload.message
            if(action.payload.success===true){
                const RequiredData = action.payload.AllCmsDelegateTicket.map((listing,index) => ({
                    ...listing,
                    id: index+1,
                }));
            state.DelegateTicketCms = RequiredData
            }
        })
        .addCase(GetAllDelegateTicketCms.rejected, (state, action)=>{
            state.isLoading = false
            state.isError=true
            state.message = action.payload
            state.DelegateTicketCms={_id:"",DelegateTicketName:"",DelegateTicketPrice:""}
        })

        .addCase(CreateDelegateTicketCms.pending, (state, action)=>{
            state.isLoading = true
        })
        .addCase(CreateDelegateTicketCms.fulfilled, (state, action)=>{
            state.isLoading = false
            state.message = action.payload.message
            toast(action.payload.message)
        })
        .addCase(CreateDelegateTicketCms.rejected, (state, action)=>{
            state.isLoading = false
            state.isError=true
            state.message = action.payload
            toast(action.payload)
        })

        .addCase(DeleteSingleDelegateTicketCms.pending, (state, action)=>{
            state.isLoading = true
        })
        .addCase(DeleteSingleDelegateTicketCms.fulfilled, (state, action)=>{
            state.isLoading = false
            state.message = action.payload.message
            toast(action.payload.message)
        })
        .addCase(DeleteSingleDelegateTicketCms.rejected, (state, action)=>{
            state.isLoading = false
            state.isError=true
            state.message = action.payload
            toast(action.payload)
        })
    }
})


export const {reset,filterState} = DelegateTicketCmslice.actions
export default DelegateTicketCmslice.reducer